// @ts-nocheck
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const RELEASES = [
  { version: 'v1.2', date: '2026-03', current: true, color: '#2D7A3A', itemsKey: 'v12' },
  { version: 'v1.1', date: '2026-03', current: false, color: '#2D7A3A', itemsKey: 'v11' },
  { version: 'v1.0', date: '2026-02', current: false, color: '#888', itemsKey: 'v10' },
]

const ROADMAP_ICONS = ['📻', '📷', '📋', '👨‍👩‍👧', '🌙']

export default function Changelog() {
  const navigate = useNavigate()
  const { t } = useTranslation()

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <div style={{ backgroundColor: '#fff', borderBottom: '1px solid #f0f0f0' }}>
        <div style={{ maxWidth: 600, margin: '0 auto', padding: '16px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <button style={{ background: 'none', border: 'none', fontSize: 16, color: '#888', cursor: 'pointer', padding: 0 }} onClick={() => navigate(-1)}>‹ {t('changelog.back')}</button>
        </div>
      </div>

      <div style={{ maxWidth: 600, margin: '0 auto', padding: '24px 20px' }}>
        <h2 style={{ fontSize: 22, fontWeight: 700, color: '#1a1a1a', margin: '0 0 4px' }}>
          {t('changelog.title')}
        </h2>
        <p style={{ fontSize: 14, color: '#888', margin: '0 0 32px' }}>
          {t('changelog.subtitle')}
        </p>

        {RELEASES.map((release) => {
          const items = t(`changelog.${release.itemsKey}.items`, { returnObjects: true }) as string[]
          return (
            <div key={release.version} style={{ marginBottom: 32 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
                <span style={{ backgroundColor: release.color, color: '#fff', fontSize: 12, fontWeight: 700, padding: '3px 10px', borderRadius: 20 }}>{release.version}</span>
                <span style={{ fontSize: 13, color: '#aaa' }}>{release.date}</span>
                {release.current && (
                  <span style={{ fontSize: 12, color: release.color, fontWeight: 600 }}>
                    {t('changelog.currentVersion')}
                  </span>
                )}
              </div>
              <div style={{ backgroundColor: '#fff', borderRadius: 16, padding: '16px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' }}>
                {items.map((item, i) => (
                  <p key={i} style={{ fontSize: 14, color: '#333', margin: i === 0 ? 0 : '10px 0 0', lineHeight: 1.5 }}>{item}</p>
                ))}
              </div>
            </div>
          )
        })}

        <h3 style={{ fontSize: 16, fontWeight: 700, color: '#1a1a1a', margin: '8px 0 16px' }}>
          {t('changelog.roadmapTitle')}
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {(t('changelog.roadmap', { returnObjects: true }) as {title:string, desc:string}[]).map((item, i) => (
            <div key={i} style={{ backgroundColor: '#fff', borderRadius: 16, padding: '14px 18px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)', display: 'flex', gap: 14, alignItems: 'flex-start' }}>
              <span style={{ fontSize: 24, lineHeight: 1.3 }}>{ROADMAP_ICONS[i]}</span>
              <div>
                <p style={{ fontSize: 15, fontWeight: 600, color: '#1a1a1a', margin: 0 }}>{item.title}</p>
                <p style={{ fontSize: 13, color: '#888', margin: '3px 0 0', lineHeight: 1.5 }}>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <p style={{ fontSize: 12, color: '#bbb', textAlign: 'center', marginTop: 32 }}>
          {t('changelog.ideaNote')}
        </p>
      </div>
    </div>
  )
}
